import * as z from 'zod';
import { RatControlServiceSchema } from 'model/ratControl/ratControlServiceSchema';

export const parseRatControlServiceList = (value: unknown) => {
    return z.array(RatControlServiceSchema).min(1).parse(value);
};
